import React, { useState } from 'react';

import './Toggler.scss';

interface IToggler {
  leftText: string;
  rightText: string;
  handler: (output: string) => void;
}

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
export default function Toggler({ leftText, rightText, handler }: IToggler): JSX.Element {
  const [toggle, setToggle] = useState(false);

  const triggerToggle = () => {
    setToggle(!toggle);
    handler(toggle ? leftText : rightText);
  };

  return (
    <div onClick={triggerToggle} className="Toggler">
      <div className="Toggler__container">
        <div className={`Toggler__indicator ${toggle ? 'indicator-left' : 'indicator-right'} `} />
        <div className={`Toggler__left fcc ${!toggle ? 'active' : ''} `}>
          <span>{leftText}</span>
        </div>
        <div className={`Toggler__right fcc ${toggle ? 'active' : ''} `}>
          <span>{rightText}</span>
        </div>
      </div>
    </div>
  );
}
